import { render } from "./PostPage.vue?vue&type=template&id=28cfe968&scoped=true"
import script from "./PostPage.vue?vue&type=script&lang=js"
export * from "./PostPage.vue?vue&type=script&lang=js"

import "./PostPage.vue?vue&type=style&index=0&id=28cfe968&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28cfe968"]])

export default __exports__